// extracted by mini-css-extract-plugin
export default {"assetOwnerList":"IsolatedViews_assetOwnerList__6oNLV"};